import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import { ExpertiseListModel } from "../../../../hooks/partners/models/ExpertiseListModel";
import { defaultProfileImage } from "../../../../utils/constants";

type Props = {
    item: ExpertiseListModel;
    partner: any;
}

export const ExpertiseCard = ({ item, partner }: Props) => {
    const [expanded, setExpanded] = useState(false);
    // Solo se muestra READ MORE si el texto de verdad se corta: en una descripcion de dos lineas
    // el boton sobra y ademas confunde, porque al pulsarlo no pasa nada visible.
    const [isTruncated, setIsTruncated] = useState(false);
    const descriptionRef = useRef<HTMLSpanElement>(null);

    const measure = useCallback(() => {
        const el = descriptionRef.current;
        if (!el) return;
        // Con el clamp aplicado, scrollHeight es la altura real del texto y clientHeight la
        // recortada. Si son iguales, cabe completo.
        setIsTruncated(el.scrollHeight > el.clientHeight + 1);
    }, []);

    useLayoutEffect(() => {
        if (!expanded) measure();
    }, [expanded, item.description, measure]);

    useEffect(() => {
        // La card cambia de ancho con el drawer y al redimensionar, y eso cambia cuantas lineas
        // ocupa el texto.
        window.addEventListener('resize', measure);
        return () => window.removeEventListener('resize', measure);
    }, [measure]);

    return (
        <div className="expertise-list-item">
            <div className="profile">
                <div className="quote">
                    <span>{item.partner.companyName}</span>
                </div>
                <img src={partner?.logo ?? defaultProfileImage} />
            </div>
            <div className="info">
                <div className="d-flex flex-row justify-content-between w-100">
                    <div className="rate-card">
                        <span className="label">Rate</span>
                        <span className="value">${Number(item.rate)}/hour</span>
                    </div>
                    {item.scheduleOn && (
                        <div className="schedule-info">
                            <span className="label">Schedule On</span>
                            <span className="value">{dayjs(item.scheduleOn.slice(0, 10)).format('D MMMM YYYY')}</span>
                        </div>
                    )}
                </div>
                <div className="info-box">
                    <div className="d-flex flex-row w-100">
                        <span className="label" style={{ width: '109px' }}>EXPERTISE</span>
                        <span className="value">{item.title}</span>
                    </div>

                    <svg xmlns="http://www.w3.org/2000/svg" width="417" height="1" viewBox="0 0 417 1" fill="none">
                        <path d="M0 0.5H417" stroke="#E9E9E9"/>
                    </svg>
                    <div className="d-flex flex-row w-100">
                        <span className="label" style={{ width: '109px' }}>MESSAGE</span>
                        <div className="content" style={{ flex: '1 0 0' }}>
                            <span
                                ref={descriptionRef}
                                className={`value${expanded ? '' : ' value--clamped'}`}
                            >
                                {item.description}
                            </span>
                            {(isTruncated || expanded) && (
                                <button
                                    type="button"
                                    className="read-more-btn"
                                    onClick={() => setExpanded((prev) => !prev)}
                                    aria-expanded={expanded}
                                >
                                    {expanded ? 'READ LESS' : 'READ MORE'}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
                <button className="read-more-btn">MESSAGE</button>
            </div>
        </div>
    )
}
